import { render, staticRenderFns } from "./RestrictedProfileOverview.vue?vue&type=template&id=5712863b&"
import script from "./RestrictedProfileOverview.vue?vue&type=script&lang=js&"
export * from "./RestrictedProfileOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports